export default {
  "ORDER_WAIT_SHIP": "في انتظار الشحن",
  "Men fashion": "ملابس رجالية",
  "MyAccount_MyProfile_label_First": "الاسم الأول",
  "MyAccount_MyShippingDetails_Phone": "رقم الهاتف",
  "Page_not_found_message1": "عذرًا، لا يمكن العثور على هذه الصفحة",
  "Help": "مساعدة",
  "Sign in": "تسجيل الدخول",
  "Register": "تسجيل",
  "Category_sorting_Item": "اختيار طريقة الترتيب",
  "cart_clear": "مسح سلة التسوق",
  "Payment & Delivery": "الدفع والشحن",
  "Send my feedback": "إرسال تعليقاتي",
  "MyAccount_MyProfile_Save": "حفظ التغييرات",
  "Continue_billing": "متابعة الدفع",
  "Categories": "الفئات",
  "Read and understand": "لقد قرأت وفهمت",
  "Feel free to edit": "لا تتردد في تحرير أي تفاصيل خاصة بك لتحديث حسابك",
  "Select payment method": "تحديد طريقة الدفع",
  "Login_input_email": "بريدك الإلكتروني",
  "Login_input_first": "الاسم الأول",
  "Account": "حساب",
  "Create_Time_Asc": "تاريخ الإنشاء مرتبة تصاعديا",
  "concactus_label": "أرسل لنا تعليقات أو أسئلة",
  "Order_Grade": "تقييم الطلب",
  "wishlist_empty_desc": "يبدو أنه لا يوجد لديك أي منتجات في حقيبة التسوق الخاصة بك. ابدأ ، تسوق الآن!",
  "cartpreviewShipping_messageinfo": "سوف تتلقى تأكيد الشحن وتاريخ الوصول",
  "unsubscribe": "يمكنك إلغاء الاشتراك في أي وقت",
  "prompt": "اقتراح",
  "MyAccount_MyProfile_yinsi_message": "في Brand name ، نولي اهتمامًا شديدًا بقضايا الخصوصية ونسعى جاهدين لحماية بيانات المستخدم الشخصية. لمزيد من المعلومات حول كيفية الاعتناء واستخدام بياناتك الشخصية ، يرجى الرجوع إلى سياسة الخصوصية الخاصة بنا.",
  "About us": "حولنا",
  "or": "أو",
  "MyAccount_Order_History_All": "جميع الطلبات",
  "What_We_Improve": "كيف نحسن أنفسنا؟",
  "MyAccount_ShippingDetails_title": "تفاصيل الشحن",
  "MyAccount_Order_History_Tabs2": "في انتظار الدفع",
  "Go_back_shopping": "العودة للتسوق",
  "Product": "المنتج",
  "Order summary": "ملخص الطلب",
  "payment_order_total": "إجمالي الطلب",
  "Departments": "بيان القانون",
  "Download": "تحميل",
  "Your_Purchase_Order": "طلبك",
  "Your_Account": "حسابك",
  "order_after_sales_list_null": "لا يوجد لديك أي طلبات خدمة بعد البيع حاليًا",
  "All_After_sales_orders": "جميع طلبات خدمة ما بعد البيع",
  "Filters": "مرشحات",
  "search_results_not": "عذرًا ، لم نتمكن من العثور على أي نتائج تتعلق بالعبارة المدخلة",
  "ORDER_WAIT_RECEIPT": "في انتظار الاستلام",
  "ORDER_CLOSED": "مغلق",
  "Order_View_details": "عرض التفاصيل",
  "Subscribe_to_message": "اشترك في الرسائل المعلوماتية للاطلاع على المبيعات والأنشطة القادمة. احصل على مكافآت وعروض خاصة!",
  "TaxFee": "رسوم الضريبة",
  "Apply": "تطبيق",
  "Total_price": "السعر الكلي",
  "Description": "وصف",
  "Payment method": "طريقة الدفع",
  "Back": "العودة",
  "Empty": "يبدو أنه لم تقم بإضافة أي منتجات إلى سلة التسوق الخاصة بك حتى الآن. ابدأ التسوق الآن لملء السلة.",
  "After_sales": "خدمة ما بعد البيع",
  "Instruction3": "نعم نحن نعلم",
  "MyAccount_MyShippingDetails_Last": "الكنية",
  "MyAccount_MyShippingDetails_City": "المدينة",
  "payment_order_discount": "خصم الطلب",
  "MyAccount_Order": "تفاصيل الطلب",
  "ID_Name_Error": "يرجى إدخال اسمك على الهوية",
  "Kidswear": "ملابس أطفال",
  "Share your look": "شارك مظهرك",
  "Pay_Order": "أدفع الطلب",
  "Reset_Password": "إعادة تعيين كلمة المرور",
  "MyAccount_MyProfile_label2_pass1": "كلمة المرور الحالية",
  "Create_Time_Desc": "تاريخ الإنشاء ترتيب تنازلي",
  "Items": "العناصر",
  "Login_Register": "سجل الآن",
  "Back to homepage": "العودة إلى الصفحة الرئيسية",
  "switch_CNY": "تبديل العملة إلى اليوان الصيني",
  "Successful placed order": "لقد قمت بطلبك بنجاح. يمكنك استخدام ميزة حالة التوصيل لدينا للتحقق من حالة الطلب. ستتلقى بريدًا إلكترونيًا تأكيديًا للطلب يحتوي على تفاصيل الطلب ورابط التتبع.",
  "MyAccount_MyProfile_yinsi_link": "سياسة الخصوصية",
  "Order_Date": "تاريخ الطلب",
  "Allow order notifications": "السماح بإشعارات الطلبات",
  "MyAccount_MyProfile_Tab1": "الملف الشخصي",
  "MyAccount_ShippingDetails_changeTitle": "تغيير العنوان",
  "ID_Number": "الرقم القومي",
  "Order_after_sales_message": "تفاصيل الطلب وطلبات خدمة ما بعد البيع",
  "MyAccount_MyProfile_title2": "إذا كنت ترغب في تغيير كلمة مرور حسابك ، يرجى إدخال المعلومات التالية:",
  "Customer service": "خدمة العملاء",
  "MyAccount_MyProfile_Update": "تحديث كلمة المرور",
  "choose_language": "اختر اللغة",
  "ORDER_REFUNDING": "استرداد",
  "MyAccount_MyProfile_title1": "لا تتردد في تحرير أي من التفاصيل المدرجة أدناه لتحديث حسابك والحفاظ عليه دائمًا في الحالة الحالية",
  "ORDER_WAIT_RATE": "انتظار التقييم",
  "after_sales_refund_order": "طلب الاسترداد",
  "Who we are": "من نحن",
  "Women fashion": "ملابس نسائية",
  "Personal details": "تفاصيل شخصية",
  "Password": "كلمة المرور",
  "wishlist_empty_title": "سلة المشتريات الخاصة بك فارغة",
  "Repeat_Password": "تأكيد كلمة المرور",
  "cart_price": "المجموع الفرعي",
  "Sort_by": "ترتيب حسب",
  "Customer Reviews": "تقييمات العملاء",
  "Continue to shipping": "متابعة الشحن",
  "payment_make_order": "إرسال الطلب",
  "save_order_review": "إرسال التقييم",
  "Save_Password": "حفظ كلمة المرور",
  "cart_empty_title": "السلة فارغة",
  "TopBar_help": "المساعدة وأسئلة شائعة",
  "colseCookie": "فهمت",
  "Password_Changed": "تم تغيير كلمة المرور الخاصة بك بنجاح. يمكنك الآن العودة إلى الصفحة الرئيسية وتسجيل الدخول.",
  "Forgot Password Modal Email": "البريد الإلكتروني الخاص بك الذي تستخدمه لتسجيل الدخول:",
  "MyAccount_Personal": "الملف الشخصي",
  "cartPreviewShipping": "الشحن السريع",
  "ORDER_AFTER_SALE": "فيما بعد البيع",
  "Page_not_found": "لم يتم العثور على الصفحة",
  "Find out more": "اعرف المزيد",
  "Log into your account": "تسجيل الدخول إلى حسابك",
  "Details_and_status_orders": "تحقق من تفاصيل الطلبات وحالتها في متجرنا عبر الإنترنت. يمكنك أيضًا إلغاء الطلب أو طلب الإرجاع.",
  "Order_to_be_paid_message": "انتظار الدفع",
  "Guarantee": "ضمان",
  "Sections that interest you": "الأقسام التي تهمك",
  "payment_post_tax": "ضريبة الشحن",
  "ORDER_PAID": "تم الدفع",
  "concactus_label5": "اللقب",
  "Item": "سلعة",
  "Go_back": "العودة",
  "more": "المزيد",
  "MyAccount": "حسابي",
  "payment_agree_1": "قبول",
  "total_items": "مجموع العناصر",
  "shopping_go": "إدارة عنوان الشحن",
  "ID_Type": "نوع هوية",
  "after_sales_status": "حالة البيع بعد البيع",
  "After_sales_apply": "تطبيق البيع بعد البيع",
  "Login": "تسجيل الدخول",
  "Quantity": "الكمية",
  "payment_post_fee": "رسوم الشحن",
  "MyAccount_Log_out": "تسجيل الخروج",
  "Subtotal": "المجموع الفرعي",
  "forgotPasswordConfirmation": "شكرًا لك! ستتلقى رسالة إلكترونية تحتوي على رابط إعادة تعيين كلمة المرور الخاصة بك إذا كانت مسجلة باستخدام بريد {0}.",
  "MyAccount_Order_History_Tabs1": "تاريخ الطلبيات",
  "concactus_img": "تحميل صورة",
  "Done": "تم",
  "Info after order": "يمكنك تسجيل الدخول إلى حسابك باستخدام البريد الإلكتروني وكلمة المرور التي حددتها سابقًا. في حسابك ، يمكنك تحرير معلومات حسابك الشخصية وعرض سجل المعاملات وتحرير اشتراكات النشرة الإخبارية وما إلى ذلك.",
  "MyAccoubnt_Set_newsletter": "حدد اشتراكاتك في النشرة الإخبارية ، التي سيتم إرسال حصرية تتعلق بمنتجات جديدة واتجاهات مختارة من قبلك إلى بريدك الإلكتروني أسبوعيًا.",
  "Shipping_method": "طريقة الشحن",
  "after_sales_refund": "مبلغ الاسترداد",
  "After_sales_save": "حفظ معلومات البيع بعد البيع",
  "go_order_history": "رؤية سجل الطلبيات",
  "contactus_message_placeholder": "أدخل تعليقاتك أو أسئلتك",
  "Login_Forgot_Password": "إذا كنت لا تتذكر كلمة المرور الخاصة بك ، يمكنك إعادة تعيينها.",
  "show_more": "عرض المزيد",
  "MyAccount_MyProfile_label_email": "بريدك الإلكتروني",
  "MyAccount_MyProfile_label2_pass3": "تأكيد كلمة المرور",
  "Products": "المنتجات",
  "Review": "مراجعات",
  "MyAccount_MyProfile_title3": "عنوان بريدك الإلكتروني الحالي هو",
  "Category_found_Products": "المنتجات الموجودة في فئة",
  "Match": "توافق",
  "Read_all_reviews": "قراءة جميع المراجعات",
  "Commercial information": "أوافق على استلام معلومات تجارية شخصية من العلامة التجارية عبر البريد الإلكتروني",
  "Change password your account": "إذا كنت ترغب في تغيير كلمة مرور الوصول إلى حسابك، يرجى إدخال المعلومات التالية",
  "ID_Name": "اسم حامل البطاقة",
  "All": "الكل",
  "Instruction2": "فقط بحاجة إلى تعليمات الصيانة؟",
  "MyAccount_ShippingDetails_Add": "أضف عنوان جديد",
  "MyAccount_MyShippingDetails_Zip": "الرمز البريدي",
  "go_pay_order": "الذهاب إلى الدفع",
  "Thank_You_Inbox": "إذا لم تصل الرسالة إلى البريد الوارد خاصتك ، يرجى المحاولة باستخدام عنوان بريد إلكتروني آخر قد تكون قد استخدمته الخاص بالتسجيل.",
  "Subscribe": "الاشتراك",
  "confirm_subscription": "آوافق على الاشتراك",
  "Login_input_Remember": "تذكرني",
  "Add to compare": "أضف للمقارنة",
  "Brand": "العلامة التجارية",
  "Start_shopping": "بدء التسوق",
  "Select shipping method": "اختر طريقة الشحن",
  "address CN": "العنوان في الصين ، يجب أن تكون العملة الحالية اليوان الصيني",
  "MyAccount_MyShippingDetails_State": "الولاية / المقاطعة",
  "Page_not_found_message2": "من فضلك اعد المحاولة او ارجع",
  "Go_to_checkout": "الذهاب للدفع",
  "See all results": "عرض جميع النتائج",
  "search_results_inputnull": "لم تقم بالبحث عن أي منتج. ",
  "subscribeToNewsletterModalContent": "عند الاشتراك في النشرة الإخبارية ، ستتلقى عروضًا خاصة ومعلومات حصرية من VSF عبر البريد الإلكتروني المحدد. لن نبيع أو نوزع عنوان بريدك الإلكتروني لأي طرف ثالث في أي وقت. يرجى الرجوع إلى {0} الخاص بنا.",
  "Download all": "تحميل الكل",
  "Login_input_last": "اسم العائلة",
  "Amount": "الكمية",
  "ORDER_WAIT_PAYMENT": "بإنتظار الدفع",
  "Order_After_sales": "خدمة ما بعد البيع للطلبات",
  "concattus_button": "تقديم",
  "Shipping_valid_required": "هذا الحقل مطلوب",
  "Price": "السعر",
  "ID_Type_Error": "يرجى اختيار نوع بطاقة الهوية الخاصة بك",
  "Order_Status": "حالة الطلب",
  "Payment methods": "طرق الدفع",
  "MyAccount_MyProfile_Tab2": "تغير كلمة المرور",
  "Show on page": "اظهار على الصفحة",
  "Edit": "تحرير",
  "Change": "تغيير",
  "MyAccount_ShippingDetails_Update": "تحديث العنوان",
  "View": "عرض",
  "Privacy": "الخصوصية",
  "Enter_promo_code": "ادخل كود الموسم",
  "Discount": "صنف",
  "Delete": "حذف",
  "Wishlist": "قائمة الأمنيات",
  "MyAccount_Order_History_Tabs3": "إرجاع",
  "Go_To_Order_review": "الانتقال للتقييم",
  "Update personal data": "تحديث بيانات شخصية",
  "payment_agree_2": "الشروط والأحكام",
  "or fill the details below": "أو أدخل التفاصيل أدناه",
  "Contact details updated": "حافظ على عنوانك وتفاصيل الاتصال محدثة.",
  "Login_Create": "أنشئ حساب",
  "Payment": "الدفع",
  "Billing": "محاسبة",
  "payment_insurance_tax": "ضريبة التأمين",
  "Size guide": "دليل المقاسات",
  "Login_forgotten_password": "هل نسيت كلمة المرور؟",
  "Login_no_account": "لا يوجد حساب بعد؟",
  "Privacy_Policy": "سياسة الخصوصية",
  "BootomCookieTitle": "تصريح عن ملفات الارتباط",
  "Use your personal data": "في Brand name، نولي اهتمامًا كبيرًا لمسائل الخصوصية، ونسعى جاهدين لحماية بيانات المستخدمين الشخصية لدينا. يرجى الاطلاع على ",
  "Review my order": "عرض طلبي",
  "BootomCookieLink": "المزيد من المعلومات",
  "hide": "إخفاء",
  "MyAccount_ShippingDetails_message_title": "ادارة جميع عناوين الشحن التي تريدها (مكان العمل ، العنوان المنزلي إلخ) بحيث لا تضطر إلى إدخال عنوان الشحن يدوياً في كل طلب.",
  "Purchase terms": "شروط الشراء",
  "Billing_address": "عنوان الفوترة",
  "Manage shipping addresses": "إدارة جميع عناوين الشحن التي تريدها (مكان العمل ، العنوان المنزلي إلخ) بحيث لا تضطر إلى إدخال عنوان الشحن يدوياً في كل طلب.",
  "login_logbtn": "تسجيل الدخول",
  "choose_currency": "اختيار العملة",
  "ORDER_REFUNDED": "تم استرداد الطلب",
  "After_sales_form": "إكمال نموذج خدمة العملاء",
  "add_To_Wishlist": "اضافة لقائمة الأمنيات",
  "search_results_inputnull2": "ابدأ الآن وسنساعدك.",
  "Total": "الإجمالي",
  "Subscribe_to_newsletter": "إشترك في النشرة الإخبارية",
  "Shipping_valid_Phone": "يرجى إدخال رقم هاتف صحيح",
  "concactus_label3": "عنوان البريد الإلكتروني",
  "Manage billing addresses": "إدارة جميع عناوين الفوترة التي تريدها (مكان العمل ، العنوان المنزلي إلخ) بحيث لا تضطر إلى إدخال عنوان الفوترة يدوياً في كل طلب.",
  "Search_results_title": "نتائج البحث",
  "payment_order_payment": "دفع الطلب",
  "after_sales_Id": "معرف خدمة ما بعد البيع",
  "cart_title": "عربة التسوق الخاصة بي",
  "Order_Detail": "تفاصيل الطلب",
  "concactus_label2": "رابط المتجر",
  "Shipping_valid_length_min": "يجب أن يتألف هذا الحقل من {min} حروف على الأقل",
  "Product suggestions": "اقتراحات المنتجات",
  "Return_home": "العودة إلى الصفحة الرئيسية",
  "Quality in the details": "جودة التفاصيل",
  "Continue_to_payment": "الاستمرار في الدفع",
  "Feedback": "تعليقك مهم بالنسبة لنا. يرجى إخبارنا بما يمكننا تحسينه.",
  "Go back to shop": "العودة للتسوق",
  "Back_to_home": "العودة إلى الصفحة الرئيسية",
  "Review_Content": "محتوى التقييم",
  "add_To_Cart": "أضف لسلة التسوق",
  "Read_reviews": "قراءة التعليقات",
  "Instruction1": "تعليمات العناية",
  "Email_address": "عنوان البريد الإلكتروني",
  "Category_Item_List": "تبديل عرض قائمة",
  "Same as shipping address": "مثل عنوان التسليم",
  "Category_Item_Grid": "تبديل عرض الشبكة",
  "ID_Number_Error": "يرجى إدخال رقم بطاقة الهوية الخاصة بك",
  "concactus_label4": "الايميل",
  "Additional_info": "معلومات إضافية",
  "add_shipping": "إضافة عنوان الشحن الجديد",
  "Product_description": "تصميم قميص Karissa V-Neck يناسب جميع الأحجام فهو يحتضن الخطوط بشكل جيد ويغطي مناطق 'المشكلة' الشائعة ، مما يسمح لك بالذهاب إلى الصالة الرياضية بثقة. بالإضافة إلى فساتين حفلة الكوكتيل والأحداث.",
  "Login_create_account": "أريد إنشاء حساب",
  "after_sales_Reason": "سبب خدمة ما بعد البيع",
  "MyAccount_MyProfile_label_Last": "الكنية",
  "MyAccount_MyProfile_label2_pass2": "كلمة مرور جديدة",
  "Save": "حفظ",
  "CartSliderTextBtn": "حفظ للشراء فيما بعد",
  "Color": "اللون",
  "Shipping_Tax": "ضريبة الشحن",
  "Subscribe_to_success": "لقد اشتركت",
  "Enjoy your free account": "تمتع بامتيازات حسابك الحرة!",
  "cart_empty_desc": "بداية لا يوجد منتجات مضافة إلى سلة التسوق.ابدأ التسوق الآن",
  "MyAccount_ShippingDetails_message_title2": "حافظ على عنوانك وتفاصيل الاتصال محدثة.",
  "An_error_occured": "حدث خطأ",
  "Country": "الدولة",
  "MyAccount_MyShippingDetails_First": "الاسم الأول",
  "payment_insurance_fee": "رسوم التأمين",
  "Home": "الصفحة الرئيسية",
  "Contact_us": "اتصل بنا",
  "Cookies Policy": "سياسة ملفات تعريف الارتباط",
  "Clear all": "مسح الكل",
  "Basket": "سلة التسوق",
  "MyAccount_MyProfile_reqeatPassErrMsg": "كلمة المرور الجديدة غير متطابقة",
  "Your current email address is": "عنوان البريد الإلكتروني الخاص بك الحالي هو",
  "You currently have no orders": "لا يوجد أي طلبات لديك حاليًا",
  "Login_input_password": "كلمة المرور",
  "Promo_code": "رمز العرض الترويجي",
  "order_count": "عدد الطلبات",
  "email_geshi_error": "الرجاء إدخال عنوان بريد إلكتروني صالح",
  "your_email": "بريدك الإلكتروني",
  "email": "البريد الإلكتروني",
  "you_have_subscribed": "لقد اشتركت بنجاح",
  "cancel_Subscribe": "إلغاء الاشتراك",
  "save_and_pay": "حفظ ودفع",
  "hasInsurance": "هل لديك تأمين؟",
  "pleasePayType": "يرجى اختيار طريقة الدفع",
  "zhuanfa_toBePay": "تحويل الدفع إلى صديق للدفع بدلاً منك",
  "linkCopied": "تم نسخ الرابط، انسخه وشاركه مع أصدقائك",
  "Links": "الروابط",
  "article_category": "تصنيف المقالات",
  "wechat_code_login_message": "يرجى استخدام مسح الرمز الشريطي لتسجيل الدخول باستخدام WeChat",
  "wechat_code_login": "WeChat تسجيل الدخول بمسح الرمز الشريطي",
  "Api_Update_success": "تم التحديث بنجاح",
  "Please_Use_WeChat_login": "يرجى استخدام WeChat لتسجيل الدخول",
  "mobile_geshi_error": "الرجاء إدخال رقم الهاتف الصحيح",
  "Login_input_email_required": "الرجاء إدخال البريد الإلكتروني",
  "article_null": "لا تتوفر مقالات حاليًا",
  "Login_with_microsoft": "تسجيل الدخول من خلال مايكروسوفت",
  "article_null_des": "يمكنك تصفح مقالات أخرى في فئات أخرى",
  "register_email": "تسجيل البريد الإلكتروني",
  "Login_tab_email": "تسجيل الدخول بالبريد الإلكتروني",
  "code.time": "{time} ثانية لأعادة المحاولة",
  "Login_with_wechat": "تسجيل الدخول بواسطة WeChat",
  "cat_items_null_des": "يمكنك تصفح منتجات أخرى في فئة أخرى",
  "Login_with_facebook": "تسجيل الدخول عبر فيسبوك",
  "Login_input_code": "الرمز التحققي",
  "Login_input_mobile_required": "الرجاء إدخال رقم الهاتف",
  "Login_input_mobile": "رقم هاتفك النقال",
  "cat_items_null": "لا تتوفر منتجات في هذه الفئة حاليًا",
  "Login_with_twitter": "تسجيل الدخول عبر تويتر",
  "mobile_code": "الرمز التحققي",
  "register_mobile": "تسجيل الجوال",
  "Login_tab_mobile": "تسجيل الدخول بالجوال",
  "Login_with_google": "تسجيل الدخول عبر Google",
  "OrderSku": "المواصفات",
  "Order_logisticsNo": "رقم الشحن",
  "order_shopping_firstname": "الاسم الأول",
  "Order_logisticsName": "اسم الشركة اللوجستية",
  "ItemPrice": "قيمة المنتج",
  "inPayOrderAll": "قائمة الدفع المعلقة",
  "payPrice": "مبلغ الدفع",
  "shipping_add_success": "تم إنشاء عنوان الشحن بنجاح",
  "match_goods": "البضائع الساخنة",
  "pay_code_refresh": "تحديث رمز الدفع",
  "pay_code_shixiao": "لقد انتهت صلاحية رمز الدفع",
  "concactus_title": "اتصل بنا",
  "Search_items": "البحث",
  "WebAutoLang": "لغة المتصفح الحالية الموصى بها هي: {lang}، هل ترغب في التحول إلى هذه اللغة؟",
  "Services_Name": "اسم الخدمة",
  "Services_Price": "تكلفة الخدمة",
  "SwichLang": "تغيير اللغة",
  "Services_Description": "وصف الخدمة",
  "goodinfo_null": "لا يوجد اي منتج حاليا",
  "goodinfo_null_des": "يمكنك تصفح منتجات الأقسام الأخرى",
  "notYetUseCode": "لم يتم استخدام رمز الخصم بعد",
  "guest_Login": "تسجيل الدخول كضيف",
  "billing_and_shipping": "الفواتير وعناوين الشحن متطابقة",
  "select_coupon": "اختر القسيمة",
  "select_gift": "اختر هدية",
  "currentUseCode": "تم استخدام رمز الخصم بالفعل",
  "shipping_refresh": "تحديث القائمة",
  "Shipping_details": "عنوان الشحن",
  "MyAccount_Newsletter": "النشرة الإخبارية",
  "MyAccount_Profile": "الملف الشخصي",
  "MyAccount_Wishlist": "قائمة الرغبات",
  "See_all": "الكل",
  "MyAccount_History": "سجل الطلبات",
  "bind_microsoft": "ربط مايكروسوفت",
  "bind_twitter": "ربط تويتر",
  "bind_facebook": "ربط فيسبوك",
  "bind_wechat_code": "رمز الاستجابة السريعة لويشات",
  "bind_wechat": "ربط ويشات",
  "bind_google": "ربط جوجل",
  "Wishlist_Empty": "لا يوجد قائمة رغبات",
  "discount_post_fee": "خصم على الشحن",
  "ORDER_PART_PAID": "دفع جزئي للطلب",
  "claimCouponeSuccess": "تم الحصول على {name} بنجاح",
  "discount_kou": "{discount}折",
  "claimCoupone": "الحصول على",
  "cartPreviewSafety_messageinfo": "تسليم آمن وسريع إلى عنوانك",
  "Order_No": "رقم الطلب",
  "cartPreviewSafety": "توصيل آمن",
  "Shipping": "الشحن",
  "MyAccount_MyShippingDetails_Street": "الشارع",
  "MyAccount_MyShippingDetails_HouseNumber": "رقم المنزل",
  "Shipping_title": "عنوان الشحن",
  "Offline_payment": "الدفع ال电线ي",
  "shopName": "اسم المتجر",
  "Social": "التواصل الاجتماعي",
  "SERVICE": "خدمة",
  "onlineContact": "الاتصال عبر الإنترنت",
  "confirm": "تأكيد",
  "closeOrder": "إلغاء الطلب",
  "closeOrderContext": "هل تريد بالتأكيد إلغاء الطلب؟",
  "Message_Read": "تم القراءة",
  "close.order.success": "تم إلغاء الطلب بنجاح",
  "shippingAddress": "العنوان بالتفصيل",
  "Message": "الرسالة",
  "Message_Empty_Title": "رسالتك فارغة",
  "MyAccount_Message": "الرسائل",
  "Message_Empty": "لا توجد رسائل",
  "payment_order_note": "ملاحظة الطلب",
  "go_to_see_prepid": "انقر هنا للعرض على الطلبات التي لم تدفع بعد",
  "operate": "العملية",
  "removeCartItemContext": "هل أنت متأكد أنك تريد إزالة {title}؟",
  "shippingItemQty": "كمية الشحن",
  "removeCartItem": "إزالة البضائع",
  "shippingInfo": "معلومات الشحن",
  "Distributor_success": "تم تحويل المستخدم إلى موزع بنجاح",
  "Distributor_apply": "تقديم طلب لتصبح موزع",
  "Distributor_Details": "موزع",
  "DistributorSataus": "الحالة",
  "Distributor_Details_Empty": "لا يوجد موزع حالياً",
  "distributor.status.4": "تم إلغاءه",
  "distributor.status.1": "لم يتم التحقق منه",
  "Distributor_copy_url": "نسخ رابط الموزع",
  "Order_Time": "وقت الطلب",
  "Order_User": "المستخدم الذي قام بالطلب",
  "Distributor_copy_success": "تم نسخ الرابط بنجاح",
  "distributor.status.3": "تم تسوية الحساب",
  "MyAccount_Distributor": "موزع",
  "MyAccoubnt_Set_Distributor": "تقديم طلب لتصبح موزع",
  "distributor.status.2": "في انتظار التسوية",
  "DistributorAmount": "العمولة",
  "Distributor_shenheshibai": "لم يتم اجتياز مراجعة الموزع",
  "Distributor_shenhezhong": "قيد المراجعة من قبل الموزعين",
  "Distributor_Order_Empty": "لا يوجد طلبات توزيع حالياً",
  "NE": "نيجيريا",
  "DJ": "جيبوتي",
  "KP": "كوريا الشمالية",
  "US": "الولايات المتحدة الأمريكية",
  "LC": "سانت لوسيا",
  "NL": "هولندا",
  "CD": "جمهورية الكونغو الديمقراطية",
  "IS": "أيسلندا",
  "MA": "المملكة المغربية",
  "GH": "غانا",
  "KR": "كوريا الجنوبية",
  "MK": "مقدونيا",
  "HT": "هايتي",
  "PF": "بولينيزيا الفرنسية",
  "GA": "الجابون",
  "TD": "تشاد",
  "LB": "لبنان",
  "CG": "الكونغو",
  "KG": "قيرغيزستان",
  "TA": "تريستان دا كونها",
  "KW": "الكويت",
  "TL": "تيمور الشرقية",
  "IN": "الهند",
  "NO": "النرويج",
  "NG": "نيجيريا",
  "AQ": "القارة القطبية الجنوبية",
  "LY": "ليبيا",
  "NI": "نيكاراغوا",
  "TT": "ترينيداد وتوباغو",
  "HM": "جزر هيرد وماكدونالد",
  "PY": "باراغواي",
  "BA": "البوسنة والهرسك",
  "JP": "اليابان",
  "MD": "مولدوفا",
  "MT": "مالطا",
  "RE": "ريونيون",
  "UG": "أوغندا",
  "SB": "جزر سليمان",
  "SL": "سيراليون",
  "CV": "الرأس الأخضر",
  "SD": "السودان",
  "FO": "جزر فارو",
  "ZA": "جنوب أفريقيا",
  "TR": "تركيا",
  "FK": "جزر فوكلاند",
  "PA": "بنما",
  "GF": "غويانا الفرنسية",
  "TJ": "طاجيكستان",
  "NC": "كاليدونيا الجديدة",
  "PM": "سان بيير وميكلون",
  "NU": "نيوي",
  "AO": "أنغولا",
  "VN": "فيتنام",
  "GN": "غينيا",
  "MW": "ملاوي",
  "BY": "بيلاروسيا",
  "IM": "جزيرة مان",
  "BI": "بوروندي",
  "BS": "البهاما",
  "CK": "جزر كوك",
  "MH": "جزر المارشال",
  "CR": "كوستاريكا",
  "HK": "هونغ كونغ، الصين",
  "AD": "أندورا",
  "BN": "بروناي",
  "SN": "السنغال",
  "AE": "الإمارات العربية المتحدة",
  "GI": "جبل طارق",
  "CA": "كندا",
  "AX": "جزر أولاند",
  "UY": "أوروغواي",
  "WF": "واليس وفوتونا",
  "GM": "غامبيا",
  "SO": "الصومال",
  "RU": "روسيا",
  "PL": "بولندا",
  "FM": "ميكرونيزيا",
  "ET": "اثيوبيا",
  "EE": "استونيا",
  "SK": "سلوفاكيا",
  "AS": "ساموا الأمريكية",
  "ZM": "زامبيا",
  "AL": "ألبانيا",
  "AT": "النمسا",
  "VA": "الفاتيكان",
  "TW": "تايوان الصينية",
  "BD": "بنغلاديش",
  "AR": "الأرجنتين",
  "EH": "الصحراء الغربية",
  "MO": "منطقة ماكاو الإدارية الخاصة في الصين",
  "MV": "جزر المالديف",
  "GU": "غوام",
  "AW": "أروبا",
  "AI": "أنغويلا",
  "CL": "تشيلي",
  "IL": "اسرائيل",
  "GD": "جرينادا",
  "WS": "ساموا",
  "SE": "السويد",
  "GP": "جزر جوادلوب",
  "YE": "اليمن",
  "GT": "جواتيمالا",
  "BG": "بلغاريا",
  "SJ": "سفالبارد وجان مايان",
  "CO": "كولومبيا",
  "LS": "ليسوتو",
  "LV": "لاتفيا",
  "UM": "جزر الولايات المتحدة البعيدة الصغيرة",
  "MX": "المكسيك",
  "DO": "جمهورية الدومينيكان",
  "PE": "بيرو",
  "HN": "هندوراس",
  "TC": "جزر توركس وكايكوس",
  "VI": "جزر فيرجن، الولايات المتحدة الأمريكية",
  "FJ": "فيجي",
  "MP": "جزر ماريانا الشمالية",
  "AC": "جزيرة أسينشيون",
  "NA": "ناميبيا",
  "SZ": "سوازيلاند",
  "RW": "رواندا",
  "BH": "البحرين",
  "KN": "سانت كيتس ونيفيس",
  "TN": "تونس",
  "AF": "أفغانستان",
  "VG": "جزر العذراء البريطانية",
  "KE": "كينيا",
  "PK": "باكستان",
  "GL": "جرينلاند",
  "SY": "سوريا",
  "CU": "كوبا",
  "RS": "صربيا",
  "BF": "بوركينا فاسو",
  "BM": "برمودا",
  "BZ": "بليز",
  "SV": "السلفادور",
  "CN": "الصين",
  "MF": "سانت مارتين",
  "NF": "جزيرة نورفولك",
  "MZ": "موزمبيق",
  "LU": "لوكسمبورغ",
  "TO": "تونغا",
  "GR": "اليونان",
  "SI": "سلوفينيا",
  "PW": "بالاو",
  "TZ": "تنزانيا",
  "IR": "إيران",
  "GG": "جيرنزي",
  "SM": "سان مارينو",
  "TF": "المقاطعات الجنوبية الفرنسية",
  "PS": "فلسطين",
  "SC": "سيشيل",
  "BT": "بوتان",
  "JM": "جامايكا",
  "BR": "البرازيل",
  "CH": "سويسرا",
  "SH": "سانت هيلينا",
  "HU": "هنغاريا",
  "TM": "تركمنستان",
  "LT": "ليتوانيا",
  "MC": "موناكو",
  "LI": "ليختنشتاين",
  "LR": "ليبيريا",
  "GE": "جورجيا",
  "SA": "المملكة العربية السعودية",
  "GB": "المملكة المتحدة",
  "VE": "فنزويلا",
  "MU": "موريشيوس",
  "HR": "كرواتيا",
  "SR": "سورينام",
  "CM": "الكاميرون",
  "IQ": "العراق",
  "BO": "بوليفيا",
  "MN": "منغوليا",
  "DZ": "الجزائر",
  "TK": "توكيلاو",
  "MG": "مدغشقر",
  "YT": "جزيرة مايوت",
  "CC": "جزر كوكوس",
  "LA": "لاوس",
  "PT": "البرتغال",
  "QA": "قطر",
  "AN": "جزر الأنتيل الهولندية",
  "PN": "جزر بيتكيرن",
  "ES": "إسبانيا",
  "VC": "سانت فنسنت وجزر غرينادين",
  "AU": "أستراليا",
  "CX": "جزيرة عيد الميلاد",
  "KM": "جزر القمر",
  "MR": "موريتانيا",
  "FR": "فرنسا",
  "SG": "سنغافورة",
  "BV": "جزيرة بوفيت",
  "PH": "الفلبين",
  "CY": "قبرص",
  "TV": "توفالو",
  "CF": "جمهورية أفريقيا الوسطى",
  "EC": "الإكوادور",
  "GW": "غينيا بيساو",
  "IE": "أيرلندا",
  "LK": "سريلانكا",
  "ER": "إريتريا",
  "GQ": "غينيا الاستوائية",
  "NP": "نيبال",
  "BE": "بلجيكا",
  "GY": "غيانا",
  "DK": "الدنمارك",
  "MQ": "مارتينيك",
  "UZ": "أوزبكستان",
  "CI": "ساحل العاج",
  "ID": "إندونيسيا",
  "BJ": "بنين",
  "ST": "ساو تومي وبرينسيبي",
  "KH": "كمبوديا",
  "KZ": "كازاخستان",
  "MS": "مونتسيرات",
  "TH": "تايلاند",
  "FI": "فنلندا",
  "ML": "مالي",
  "AM": "أرمينيا",
  "IT": "إيطاليا",
  "NR": "ناورو",
  "PG": "بابوا غينيا الجديدة",
  "ZW": "زيمبابوي",
  "JO": "الأردن",
  "OM": "عُمان",
  "ME": "الجبل الأسود",
  "JE": "جيرسي",
  "NZ": "نيوزيلندا",
  "VU": "فانواتو",
  "DE": "ألمانيا",
  "CZ": "جمهورية التشيك",
  "DM": "دومينيكا",
  "KY": "جزر كايمان",
  "BW": "بوتسوانا",
  "RO": "رومانيا",
  "PR": "بورتوريكو",
  "AZ": "أذربيجان",
  "IO": "إقليم المحيط الهندي البريطاني",
  "UA": "أوكرانيا",
  "TG": "توغو",
  "MY": "ماليزيا",
  "AG": "أنتيجوا وبربودا",
  "EG": "مصر",
  "GS": "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
  "MM": "ميانمار",
  "BB": "بربادوس",
  "KI": "كيريباتي",
  "All_Country": "الكل",
  "post_state_country": "رسوم الشحن: {country} {state} {postFee} ",
  "zhichiDeliveryCountry": "الشحن إلى",
  "ShippingFee": "رسوم الشحن",
  "reviewOutOf": "{تقييم} نجوم، من 5 نجوم",
  "product.pifa.label": "شراء {startnum} - {endnum} قطعة",
  "product.pifa.type.1": "خصم",
  "Write_a_review": "كتابة تعليق",
  "BasedOnTotalReviews": "بناءً على {total} تقييم",
  "product.wholesale": "سعر جملة",
  "reviewMostRecent": "آخر التعليقات",
  "product.pifa.type.2": "سعر الوحدة",
  "product.num.danwei": "الشخصيات",
  "good.shoppingDateLabel": "وقت الشحن",
  "good.shippingPeriod": "الشحن في غضون أيام",
  "emailError": "خطأ في تنسيق البريد الإلكتروني",
  "addressNote": "ملاحظة العنوان",
  "Concactus": "اتصل بنا",
  "addressMessage": "يرجى التأكد من صحة عنوانك. لا يمكننا تغيير العنوان بعد الدفع.",
  "showOrderSummary": "ملخص الطلب",
  "payment_method": "طريقة الدفع",
  "emailNotNullError": "البريد الإلكتروني لا يمكن أن يكون فارغًا",
  "orderCreateLoading": "جاري إنشاء الطلب...",
  "emailNote": "اتصل بنا",
  "emailMessage": "يرجى التأكد من صحة عنوان بريدك الإلكتروني. سنرسل لك بريدًا إلكترونيًا لتأكيد الطلب.",
  "payment_method_message": "جميع المعاملات آمنة ومشفرة.",
  "go_buy_goods": "مواصلة التسوق",
  "tap_cancel_order": "انقر هنا لإلغاء الطلب",
  "order_review": "تقييم الطلب",
  "Add_new_address": "إضافة عنوان جديد",
  "promo_code_type_3": "قسيمة هدايا لشراء كامل",
  "IdCardNotNull": "الرجاء تعبئة المعلومات ال...fied information",
  "promo_code_type_1": "قسيمة خصم",
  "shippingInfoNotNull": "معلومات الشحن غير مكتملة",
  "UploadVideo": "تحميل الفيديو",
  "video": "فيديو",
  "UploadImage": "تحميل صورة",
  "uploadImageing": "جاري التحميل...",
  "BillingInfoNotNull": "معلومات الفواتير غير كاملة",
  "promo_code_type_2": "قسيمة نقدية",
  "UploadError": "فشل التحميل",
  "promo_code_type_4": "قسيمة خصم الشحن",
  "image": "صورة",
  "paymentMethodNotNull": "يرجى اختيار طريقة الدفع",
  "reviewDetail": "تفاصيل التقييم",
  "DeliveryCountry": "منطقة التسليم",
  "prompt_error": "تنبيه خطأ",
  "save_review_success": "تم حفظ التقييم بنجاح",
  "ORDER_COMPLETED": "تم الانتهاء منه",
  "crate_after_sales": "إنشاء بيع ما بعد الخدمة",
  "Thank_You_Order": "شكراً لطلبك!",
  "Thank_You_Order_sub": "ستبدأ معالجة طلبك قريباً، ستتلقى بريدًا إلكترونيًا يحتوي على معلومات حول معالجة الطلب.",
  "BootomCookieContext": "هذا الموقع يستخدم ملفات تعريف الارتباط (الكوكيز) لمساعدته على العمل بشكل سليم ولمساعدتنا في فهم كيفية تفاعلنا معه. نحن نستخدم هذه الكوكيز لتوفير تجربة مستخدم أفضل وأكثر شخصية. إذا استمرَّيت في استخدام هذا الموقع ، فسنفترض أنك توافق على استخدام ملفات تعريف",
  "order_reivice_message": "هل أستلمت البضاعة بالفعل؟",
  "order_reivice_btn": "تأكيد الاستلام",
  "order_reivice_label": "استلام الطلب",
  "order_reivice_success": "تم تأكيد الاستلام بنجاح",
  "collpase_show": "عرض المزيد",
  "collpase_hide": "إخفاء",
  "CouponCode": "رمز الخصم",
  "wechatPayScannerCode": "يرجى استخدام الويش اسكانر كود للدفع عبر WeChat",
  "processing": "معالجة ما بعد البيع",
  "finished": "تم الانتهاء من ما بعد البيع",
  "login.showPrice": "تسجيل الدخول لعرض السعر",
  "After_Sales_Unknown": "حالة ما بعد البيع غير معروفة",
  "order_payment_list_null": "لا توجد طلبات للدفع",
  "Cancel": "إلغاء",
  "thankyou_concat": "إذا كان لديك أي أسئلة، يرجى الاتصال بنا"
}